import axios, { AxiosResponse } from "axios";
import { ISection } from "../@types/productInfo";
// import { Faq } from "../@types/faqInfo";

export interface Faq {
    id?: any;
    category_id?: any;
    question: string;
    answer: string;
    created_at: string;
    updated_at: string;
    categoryId?:any
    title?: string;
  content?: any;
  image?: any;
  sections?: ISection[]
  }


export interface Category {
    id: number;
   name:string
   
  }
  
  

const BASE_URL = "https://sodastreamapi.azurewebsites.net/faqs";

class FaqService {

  async getAllFaqs(): Promise<{ data: Faq[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<Faq[]> = await axios.get(BASE_URL);
      if (response.status >= 200 && response.status < 300) {
        const faqs: Faq[] = response.data;
        return { data: faqs, error: null };
      } else {
        const error = "Error fetching FAQs";
        return { data: null, error };
      }
    } catch (error: any) {
      return { data: null, error };
    }
  }

  async getAllCategories(): Promise<{ data: Category[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<Category[]> = await axios.get(`${BASE_URL}/category`);
      if (response.status >= 200 && response.status < 300) {
        const faqs: Category[] = response.data;
        return { data: faqs, error: null };
      } else {
        const error = "Error fetching Category";
        return { data: null, error };
      }
    } catch (error: any) {
      return { data: null, error };
    }
  }

  async getFaqById(faqId: any): Promise<{ data: Faq | null; error: string | null }> {
    try {
      const response: AxiosResponse<Faq> = await axios.get(`${BASE_URL}/${faqId}`);
      if (response.status >= 200 && response.status < 300) {
        const faq: Faq = response.data;
        return { data: faq, error: null };
      } else {
        const error = "Error fetching FAQ by ID";
        return { data: null, error };
      }
    } catch (error: any) {
      return { data: null, error };
    }
  }

  async getFaqsByCategory(
    categoryId: number
  ): Promise<{ data: Faq[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<Faq[]> = await axios.get(`${BASE_URL}/category/${categoryId}`);
      if (response.status >= 200 && response.status < 300) {
        const faqs: Faq[] = response.data;
        return { data: faqs, error: null };
      } else {
        const error = "Error fetching FAQs by category";
        return { data: null, error };
      }
    } catch (error: any) {
      return { data: null, error };
    }
  }

  async createFaq(faqData: any): Promise<{ data: Faq | null; error: string | null }> {
    try {
      const response: AxiosResponse<Faq> = await axios.post(BASE_URL, faqData);
      if (response.status >= 200 && response.status < 300) {
        const createdFaq: Faq = response.data;
        return { data: createdFaq, error: null };
      } else {
        const error = "Error creating FAQ";
        return { data: null, error };
      }
    } catch (error: any) {
      return { data: null, error };
    }
  }

  async editFaq(
    faqId: any,
    updatedFaqData: Faq
  ): Promise<{ data: Faq | null; error: string | null }> {
    try {
      const response: AxiosResponse<Faq> = await axios.put(`${BASE_URL}/${faqId}`, updatedFaqData);
      if (response.status >= 200 && response.status < 300) {
        const editedFaq: Faq = response.data;
        return { data: editedFaq, error: null };
      } else {
        const error = `Error editing FAQ: ${response.statusText}`;
        return { data: null, error };
      }
    } catch (error: any) {
      return { data: null, error: error.message };
    }
  }

  async deleteFaq(faqId: number): Promise<{ data: boolean | null; error: string | null }> {
    try {
      const response: AxiosResponse<void> = await axios.delete(`${BASE_URL}/${faqId}`);
      if (response.status >= 200 && response.status < 300) {
        return { data: true, error: null };
      } else {
        const error = `Error deleting FAQ: ${response.statusText}`;
        return { data: null, error };
      }
    } catch (error: any) {
      return { data: null, error: error.message };
    }
  }
}

const faqServiceInstance = new FaqService();

export default faqServiceInstance;
